import _defineProperty from "/opt/build/repo/results/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/results/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/opt/build/repo/results/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["__scopeCollapsible", "open", "defaultOpen", "disabled", "onOpenChange"],
    _excluded2 = ["__scopeCollapsible"],
    _excluded3 = ["forceMount"],
    _excluded4 = ["__scopeCollapsible", "present", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useId as e } from "@radix-ui/react-id";
import { Presence as t } from "@radix-ui/react-presence";
import { Primitive as o } from "@radix-ui/react-primitive";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { useLayoutEffect as n } from "@radix-ui/react-use-layout-effect";
import { useControllableState as i } from "@radix-ui/react-use-controllable-state";
import { createContextScope as a } from "@radix-ui/react-context";
import { composeEventHandlers as l } from "@radix-ui/primitive";
import * as s from "react";
import c from "@babel/runtime/helpers/esm/extends";

var _a = a("Collapsible"),
    _a2 = _slicedToArray(_a, 2),
    p = _a2[0],
    d = _a2[1];

export { d as createCollapsibleScope };

var _p = p("Collapsible"),
    _p2 = _slicedToArray(_p, 2),
    u = _p2[0],
    m = _p2[1];

export var Collapsible = /*#__PURE__*/s.forwardRef(function (t, r) {
  var n = t.__scopeCollapsible,
      a = t.open,
      l = t.defaultOpen,
      p = t.disabled,
      d = t.onOpenChange,
      m = _objectWithoutProperties(t, _excluded),
      _i = i({
    prop: a,
    defaultProp: l,
    onChange: d
  }),
      _i2 = _slicedToArray(_i, 2),
      _i2$ = _i2[0],
      f = _i2$ === void 0 ? !1 : _i2$,
      C = _i2[1];
  /*#__PURE__*/


  return s.createElement(u, {
    scope: n,
    disabled: p,
    contentId: e(),
    open: f,
    onOpenToggle: s.useCallback(function () {
      return C(function (e) {
        return !e;
      });
    }, [C])
  }, /*#__PURE__*/s.createElement(o.div, c({
    "data-state": b(f),
    "data-disabled": p ? "" : void 0
  }, m, {
    ref: r
  })));
});
/*#__PURE__*/

export var CollapsibleTrigger = /*#__PURE__*/s.forwardRef(function (e, t) {
  var r = e.__scopeCollapsible,
      n = _objectWithoutProperties(e, _excluded2),
      i = m("CollapsibleTrigger", r);
  /*#__PURE__*/


  return s.createElement(o.button, c({
    "aria-controls": i.contentId,
    "aria-expanded": i.open || !1,
    "data-state": b(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    disabled: i.disabled
  }, n, {
    ref: t,
    onClick: l(e.onClick, i.onOpenToggle)
  }));
});
/*#__PURE__*/

export var CollapsibleContent = /*#__PURE__*/s.forwardRef(function (e, o) {
  var r = e.forceMount,
      n = _objectWithoutProperties(e, _excluded3),
      i = m("CollapsibleContent", e.__scopeCollapsible);
  /*#__PURE__*/


  return s.createElement(t, {
    present: r || i.open
  }, function (_ref) {
    var e = _ref.present;
    return /*#__PURE__*/s.createElement(f, c({}, n, {
      ref: o,
      present: e
    }));
  });
});
/*#__PURE__*/

var f = /*#__PURE__*/s.forwardRef(function (e, t) {
  var i = e.__scopeCollapsible,
      a = e.present,
      l = e.children,
      p = _objectWithoutProperties(e, _excluded4),
      d = m("CollapsibleContent", i),
      _s$useState = s.useState(a),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      u = _s$useState2[0],
      f = _s$useState2[1],
      C = s.useRef(null),
      x = r(t, C),
      g = s.useRef(0),
      h = g.current,
      R = s.useRef(0),
      D = R.current,
      v = d.open || u,
      y = s.useRef(v),
      _ = s.useRef();

  return s.useEffect(function () {
    var e = requestAnimationFrame(function () {
      return y.current = !1;
    });
    return function () {
      return cancelAnimationFrame(e);
    };
  }, []), n(function () {
    var e = C.current;

    if (e) {
      _.current = _.current || {
        transitionDuration: e.style.transitionDuration,
        animationDuration: e.style.animationDuration
      }, e.style.transitionDuration = "0s", e.style.animationDuration = "0s";

      var _t = e.getBoundingClientRect();

      g.current = _t.height, R.current = _t.width, y.current || (e.style.transitionDuration = _.current.transitionDuration, e.style.animationDuration = _.current.animationDuration), f(a);
    }
  }, [d.open, a]), /*#__PURE__*/s.createElement(o.div, c({
    "data-state": b(d.open),
    "data-disabled": d.disabled ? "" : void 0,
    id: d.contentId,
    hidden: !v
  }, p, {
    ref: x,
    style: _objectSpread({
      "--radix-collapsible-content-height": h ? "".concat(h, "px") : void 0,
      "--radix-collapsible-content-width": D ? "".concat(D, "px") : void 0
    }, e.style)
  }), v && l);
});

function b(e) {
  return e ? "open" : "closed";
}

export var Root = Collapsible;
export var Trigger = CollapsibleTrigger;
export var Content = CollapsibleContent;